import { Injectable } from '@angular/core';
import { ToastButton, ToastController, ToastOptions } from '@ionic/angular';
import { QbusTranslateService } from '../qbus-translate';

export type QbusToastOptions = ToastOptions & {
  isDismissible?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class QbusToastService {
  constructor(
    private readonly toastController: ToastController,
    private readonly qbusTranslate: QbusTranslateService,
  ) {}

  async showSuccess(
    translationKey: string,
    options: QbusToastOptions = {},
  ): Promise<HTMLIonToastElement> {
    return await this.show(translationKey, {
      color: 'success',
      ...options,
    });
  }

  async showError(
    translationKey: string,
    options: QbusToastOptions = {},
  ): Promise<HTMLIonToastElement> {
    return await this.show(translationKey, {
      color: 'danger',
      ...options,
    });
  }

  async showInfo(
    translationKey: string,
    options: QbusToastOptions = {},
  ): Promise<HTMLIonToastElement> {
    return await this.show(translationKey, options);
  }

  /**
   * Show an ion toast.
   * @param translationKey translationKey of the message
   * @param overrideDefaultOptions override the default toast options
   * @param qbusOptions custom qbus options
   */
  async show(
    translationKey: string,
    options: QbusToastOptions = {},
  ): Promise<HTMLIonToastElement> {
    const { message } = await this.qbusTranslate.translateAll({
      message: translationKey,
    });

    const toastOptions: ToastOptions = {
      color: 'medium',
      message,
      duration: 5000,
      position: 'top',
      ...options,
    };

    if (options.isDismissible !== false) {
      const button: ToastButton = {
        icon: 'close',
        role: 'cancel',
      };

      if (toastOptions.buttons) {
        toastOptions.buttons.push(button);
      } else {
        toastOptions.buttons = [button];
      }
    }

    const toast = await this.toastController.create(toastOptions);

    await toast.present();
    return toast;
  }
}
